import isNil from "lodash-es/isNil";
import isNumber from "lodash-es/isNumber";
import { observer } from "mobx-react-lite";

import type { SimplifiedProduct } from "../common/types/productTypes";
import { formatPrice, translateBaseUnit } from "../common/utils";

type PricePerItemProps = {
   product: SimplifiedProduct;
   className?: string;
};

const PricePerItem = ({ product, className = "" }: PricePerItemProps) => {
   const amount =
      product.unit === "STK" || isNil(product?.conversionFactor) || !isNumber(product.conversionFactor)
         ? 1
         : product.conversionFactor;
   const baseUnit = translateBaseUnit(product.baseUnit, amount);

   return (
      <div className={className}>
         {amount.toFixed(0)} {baseUnit} {!isNil(product.price) ? `á ${formatPrice(product.price / amount)}` : ""}
      </div>
   );
};

export default observer(PricePerItem);
